import React from 'react'
import { Text } from '@usap/uicomponents'
import {
    OrderDetailsBlueButton,
    OrderDetailsButtonContainer,
} from './style/button.css'

const BuyItAgainButton = ({ productUri, itemStatus }) => {

    return (
        productUri && itemStatus != 'Canceled' && itemStatus != 'Cancelled' ? (
            <OrderDetailsButtonContainer>
                <OrderDetailsBlueButton
                    custom
                    hideBorder
                    label={<Text size="small">Buy It Again</Text>}
                    onClick={() => {
                        window.location.href = `/${productUri}`
                    }}
                />
            </OrderDetailsButtonContainer>
        )
            :
            null
    )
}

export default BuyItAgainButton
